import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";

/**
 * The Wise lockup.
 *
 * The mark is the original one — a sun coming up over the water — kept as
 * artwork. The wordmark beside it is NOT artwork: it is set live in the site's
 * own display face, so the logo and the headings under it are the same
 * typography rather than a 2021 wordmark sitting on a 2026 page.
 *
 * That is also why this is a component and not an image: an SVG loaded through
 * `<img>` cannot see the page's webfonts, so a text-based lockup has to be real
 * DOM to render in the right face at all.
 */
@Component({
  selector: "app-brand-logo",
  imports: [CommonModule],
  templateUrl: "./brand-logo.component.html",
  styleUrl: "./brand-logo.component.scss",
})
export class BrandLogoComponent {
  /** White cut, for ink panels and the footer. */
  @Input() light = false;

  /** Drives the whole lockup: the mark is sized in em off the wordmark. */
  @Input() size: "sm" | "md" | "lg" = "md";
}
